import { FormControl, FormControlLabel, Switch } from "@mui/material";

export default function SwitchField(props) {
  const { name, label, value, onChange, checked, ...other } = props;

  const convertToDefEventPara = (name, value) => ({
    target: {
      name,
      value,
    },
  });

  return (
    <FormControl>
      <FormControlLabel control={<Switch name={name} color="primary" checked={value || checked} onChange={(e) => onChange(convertToDefEventPara(name, e.target.checked ? 1 : 0))} {...other} />} label={label} />
    </FormControl>
  );
}
